import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconKeyCollection: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.5 3c-3 0-5.5 2.5-5.5 5.5 0 .6.1 1.2.3 1.8l-8 8c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l.8-.8 1.8 1.8c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-1.8-1.8L7 16.4l2.3 2.3c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4L8.4 15l2.9-2.9c1 1.2 2.5 1.9 4.2 1.9 3 0 5.5-2.5 5.5-5.5S18.5 3 15.5 3zm0 9c-1.9 0-3.5-1.6-3.5-3.5S13.6 5 15.5 5 19 6.6 19 8.5 17.4 12 15.5 12z',
    })
  )
}
